import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProductAddToWishListComponent } from './product-add-to-wish-list.component';

@NgModule({
  declarations: [ProductAddToWishListComponent],
  imports: [CommonModule],
  exports: [ProductAddToWishListComponent],
})
export class ProductAddToWishListModule {}
